import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStats = () => {
  const stats = [
    {
      id: 1,
      label: 'Days Active',
      value: '1',
      icon: 'Calendar',
      color: 'primary',
      trend: 'Just started!'
    },
    {
      id: 2,
      label: 'Tasks Completed',
      value: '0/6',
      icon: 'CheckCircle2',
      color: 'success',
      trend: 'Let\'s begin'
    },
    {
      id: 3,
      label: 'Team Connections',
      value: '0',
      icon: 'Users',
      color: 'accent',
      trend: 'Meet your team'
    },
    {
      id: 4,
      label: 'Knowledge Articles',
      value: '12',
      icon: 'BookOpen',
      color: 'warning',
      trend: 'Available to read'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      success: 'bg-success/10 text-success',
      accent: 'bg-accent/10 text-accent',
      warning: 'bg-warning/10 text-warning'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {stats?.map((stat) => (
        <div
          key={stat?.id}
          className="bg-card rounded-lg shadow-elevation-1 border border-border p-4 hover:shadow-elevation-2 transition-all duration-200 hover:scale-102"
        >
          <div className="flex items-start justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getColorClasses(stat?.color)}`}>
              <Icon name={stat?.icon} size={20} color="currentColor" strokeWidth={2.5} />
            </div>
          </div>
          <div className="space-y-1">
            <div className="text-2xl font-bold text-foreground">{stat?.value}</div>
            <div className="text-sm text-muted-foreground">{stat?.label}</div>
            <div className="text-xs text-muted-foreground opacity-70">{stat?.trend}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickStats;